/** Keeps investor-only accounts out of Pro; multi-role users retain their existing access. */

import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "@/contexts/AuthContext";
import { ROUTES } from "@/app/routes";

interface InvestorRedirectProps {
  children: React.ReactNode;
}

export const InvestorRedirect: React.FC<InvestorRedirectProps> = ({ children }) => {
  const authContext = useContext(AuthContext);

  if (!authContext) {
    throw new Error("InvestorRedirect must be used within AuthProvider");
  }

  if (authContext.isAuthenticated && authContext.tokenManagement.isInvestorOnly()) {
    return <Navigate to={ROUTES.PORTAL_UNAVAILABLE} replace />;
  }

  return <>{children}</>;
};
